"use client";

import React from "react";
import { Award, Sparkles, Star, Trophy, Medal, GraduationCap } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const certificates = [{
  id: 1,
  title: "MFAA Accredited Broker",
  issuer: "Mortgage & Finance Association",
  year: "2024",
  icon: Trophy,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/finance_badge_mfaa.png",
  description: "Highest industry standard certification for mortgage and finance professionals, ensuring ethical standards and expert knowledge."
}, {
  id: 2,
  title: "30+ Years Experience",
  issuer: "SLA Finance Leadership",
  year: "Combined",
  icon: Award,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/finance_badge_experience.png",
  description: "Our leadership team brings decades of combined experience across residential, commercial, and asset finance sectors."
}, {
  id: 3,
  title: "Fast Loan Approvals",
  issuer: "Efficiency Excellence",
  year: "2024",
  icon: Star,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/finance_badge_fast.png",
  description: "Streamlined processing systems designed to secure formal approvals in record time, giving you the competitive edge."
}, {
  id: 4,
  title: "Expert Strategy Advice",
  issuer: "Financial Planning Guild",
  year: "Certified",
  icon: GraduationCap,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/finance_badge_strategy.png",
  description: "Specialized in crafting personalized lending strategies that align with your long-term wealth creation and financial goals."
}, {
  id: 5,
  title: "Access to 40+ Lenders",
  issuer: "Premium Network",
  year: "2024",
  icon: Medal,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1637844/img/finance_badge_lenders.png",
  description: "Extensive panel of major banks and boutique lenders ensuring we find the most competitive rates and flexible terms for you."
}];
export default function TheHallOfAchievements() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}